module.exports = __webpack_public_path__ + "static/redux-saga-95a8ddda3e602f6a2b1c8f7e03c3ad74.png";